var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBicsLogoFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 33,
    viewBox: "0 0 90 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M89.9951 26.2857C89.9951 21.6067 86.0642 20.1617 81.7824 19.2671C77.9918 18.5101 75.4648 17.4781 75.4648 15.2073C75.4648 13.4871 77.0794 11.6981 80.5891 11.6981C83.5372 11.6981 85.7132 13.2807 86.6258 14.0376L88.872 11.8357C87.8892 10.9412 85.0114 8.73926 80.5891 8.73926C75.3947 8.73926 72.0955 12.0421 72.0955 15.0698C72.0955 18.7854 74.6928 20.9185 80.5891 22.0884C83.6777 22.7076 86.5555 23.6021 86.5555 26.3545C86.5555 28.5564 83.6074 29.795 80.7997 29.795C77.7111 29.795 75.4648 28.2123 74.2715 27.1114L72.0254 29.3134C73.5697 30.7584 76.5178 32.7537 80.7997 32.7537C85.3622 32.685 89.9951 30.4831 89.9951 26.2857Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M33.278 9.2207H30.2598V32.3406H33.278V9.2207Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M43.0352 20.6428C43.0352 27.2486 48.5103 32.6845 55.3192 32.6845C58.5482 32.6845 61.5664 31.4459 63.8829 29.2439L61.7772 27.1797C60.0222 28.8311 57.7059 29.7256 55.3192 29.7256C50.195 29.7945 45.9833 25.6659 45.9833 20.6428C45.9833 15.6197 50.1249 11.5599 55.249 11.5599C57.5654 11.5599 59.7414 12.3856 61.4262 13.8994L63.532 11.8352C61.2857 9.77088 58.3376 8.66992 55.249 8.66992C48.5103 8.66992 43.0352 14.0371 43.0352 20.6428Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M9.06079 8.67C7.37612 8.67 5.76165 9.01405 4.21738 9.63333L3.51543 9.90856V0H0.49707V11.56L2.81349 13.8307C4.49815 12.3169 6.67418 11.4912 8.99059 11.4912C14.1148 11.4912 18.2563 15.5509 18.2563 20.5741C18.2563 25.5972 14.185 29.7945 9.06079 29.7945C6.67418 29.7945 4.35776 28.9 2.67309 27.2486L0.567265 29.3128C2.88368 31.5147 5.90203 32.6845 9.06079 32.6845C15.7994 32.6845 21.3448 27.3174 21.3448 20.6428C21.3448 13.9683 15.8697 8.67 9.06079 8.67Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBicsLogoFooter);
export default __webpack_public_path__ + "static/media/bics-logo-footer.00e602d7947200585152216abe7576ae.svg";
export { ForwardRef as ReactComponent };